import React, { useEffect, useState } from "react";
import ExplorerSort from "./ExplorerSort";
import ExplorerFilter from "./ExplorerFilter";
import ECLLoader from "../../../../Widgets/ECLLoader/ECLLoader";
import ECLTable from "../../../../Widgets/ECLTable/ECLTable";
import { translate } from "../../../../../utilities/Translate";
import { endpointRequest } from "../../../../../utilities/requests";

export default function ExplorerTable(props) {
   const [rowData, setRowData] = useState(null);
   const [columnSettings, setColumnSettings] = useState(null);
   const [tableSettings, setTableSettings] = useState(null);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState(null);

   //Initial Table Setting
   useEffect(() => {
      const rootId = props.headlist.at(-1);
      const sessionId = props.flatDoc[rootId].session;
      endpointRequest(
         props.parentObject,
         props.block.id,
         sessionId,
         props.endpoint,
      )
         .then((res) => {
            let newRowData = res.rows.map((r) => {
               return { row: r };
            });
            const columnOrder = res.columns.map((col) => col.name);
            const newColumnSettings = res.columns.map((col) => {
               const columnIndex = columnOrder.findIndex(
                  (columnName) => columnName === col.name,
               );
               return {
                  id: col.name,
                  label: col.name,
                  width: 200,
                  sort: (
                     <ExplorerSort
                        columnIndex={columnIndex}
                        rowData={newRowData}
                        setRowData={setRowData}
                     />
                  ),
               };
            });

            newColumnSettings.push({
               id: "Filter",
               width: 40,
               customFormatting: (rowIndex) => {
                  const filterName = newRowData[rowIndex].row[0];
                  return (
                     <ExplorerFilter
                        filterName={filterName}
                        containerId={props.id}
                        {...props}
                     />
                  );
               },
            });

            const tableSettings = {
               tableHeight: 200,
               columnOrder: columnOrder,
               rightStickyCols: ["Filter"],
               rowHeight: 40,
               noVirtualization: true,
            };
            setRowData(newRowData);
            setTableSettings(tableSettings);
            setColumnSettings(newColumnSettings);
            setLoading(false);
         })
         .catch((error) => {
            console.error(error);
            setError(translate("Error loading table"));
         });
   }, []);

   useEffect(() => {
      const rootId = props.headlist.at(-1);
      const sessionId = props.flatDoc[rootId].session;
      endpointRequest(
         props.parentObject,
         props.block.id,
         sessionId,
         props.endpoint,
      )
         .then((res) => {
            let newRowData = res.rows.map((r) => {
               return { row: r };
            });
            const columnOrder = res.columns.map((col) => col.name);
            const newColumnSettings = res.columns.map((col) => {
               const columnIndex = columnOrder.findIndex(
                  (columnName) => columnName === col.name,
               );
               return {
                  id: col.name,
                  label: col.name,
                  width: 200,
                  sort: (
                     <ExplorerSort
                        columnIndex={columnIndex}
                        rowData={newRowData}
                        setRowData={setRowData}
                     />
                  ),
               };
            });

            newColumnSettings.push({
               id: "Filter",
               width: 40,
               customFormatting: (rowIndex) => {
                  const filterName = newRowData[rowIndex].row[0];
                  return (
                     <ExplorerFilter
                        filterName={filterName}
                        containerId={props.id}
                        {...props}
                     />
                  );
               },
            });

            setRowData(newRowData);
            setColumnSettings(newColumnSettings);
            setLoading(false);
         })
         .catch((error) => {
            console.error(error);
            setError(translate("Error loading table"));
         });
   }, [props.block.react.refresh]);

   if (!tableSettings || !columnSettings || !rowData || loading || error) {
      return <ECLLoader message={error} />;
   }

   return (
      <ECLTable
         rowData={rowData}
         tableSettings={tableSettings}
         columnSettings={columnSettings}
      />
   );
}
